import {
  getStoredValue,
  removeStoredValue,
  setStoredValue,
} from "@WahooFitness/wahoo-offline-mfe/services/StorageService";

export const RECOVERY_SOURCE_AUTO_SELECT_PENDING_KEY = "recoverySourceAutoSelectPending";

type PendingAutoSelect = { fitnessAppId: number };

// The app the user set out to authorize while the account had no recovery source. Written when
// they leave for the external authorize step, consumed the first time that app shows up as
// authorized, and dropped as soon as they deliberately empty the slot or deauthorize an app,
// since either ends the flow it belongs to.
export const readPendingRecoverySourceAutoSelect = async (): Promise<
  PendingAutoSelect | undefined
> => {
  const raw = await getStoredValue<string>(RECOVERY_SOURCE_AUTO_SELECT_PENDING_KEY);
  if (!raw) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(raw) as Partial<PendingAutoSelect>;
    return typeof parsed.fitnessAppId === "number"
      ? { fitnessAppId: parsed.fitnessAppId }
      : undefined;
  } catch {
    return undefined;
  }
};

export const writePendingRecoverySourceAutoSelect = (fitnessAppId: number) =>
  setStoredValue(RECOVERY_SOURCE_AUTO_SELECT_PENDING_KEY, JSON.stringify({ fitnessAppId }));

export const clearPendingRecoverySourceAutoSelect = () =>
  removeStoredValue(RECOVERY_SOURCE_AUTO_SELECT_PENDING_KEY);
